import { cn } from '@/lib/utils.ts';

export interface BarSegment {
  id: string;
  /** Udział w całości, 0–100. Odcinki zerowe znikają, nie zwężają się do kreski. */
  pct: number;
  /** Barwa odcinka. Ekran rozwiązuje ją z tonu albo bierze z katalogu kategorii. */
  color: string;
}

interface SegmentedBarProps extends React.HTMLAttributes<HTMLDivElement> {
  segments: BarSegment[];
}

/**
 * Pasek złożony z kilku odcinków — zapłacone obok przeterminowanego obok
 * zaplanowanego. `Progress` maluje jeden wskaźnik, więc dla podziału na części
 * potrzeba osobnego komponentu; wygląd toru zostaje ten sam.
 *
 * Barwy przychodzą gotowe, bo komponent nie ma znać ani tonów statusów, ani
 * katalogu kategorii kosztów.
 */
const SegmentedBar = ({ segments, className, ...props }: SegmentedBarProps) => (
  <div
    className={cn(
      'flex h-2 w-full overflow-hidden rounded-full bg-neutral-100',
      className,
    )}
    {...props}
  >
    {segments
      .filter((segment) => segment.pct > 0)
      .map((segment) => (
        <span
          key={segment.id}
          className="h-full"
          style={{
            width: `${segment.pct}%`,
            backgroundColor: segment.color,
          }}
        />
      ))}
  </div>
);

export default SegmentedBar;
